export const OpsMenuList = [
    {
        title: "Assigned Leads",
        iconStyle: imagepaths.LeadsIconWhite,
        iconActive: imagepaths.LeadsIconWhiteActive,
        to: "/app/leadmanagement",
        id: "leadmanagement",
    },
    {
        title: "My Applications",
        iconStyle: imagepaths.applicationImg,
        iconActive: imagepaths.applicationActiveImg,
        to: "/app/applications",
        id: "applications",
    },
    {
        title: "Policies",
        iconStyle: imagepaths.shieldIconWhite,
        iconActive: imagepaths.shieldIconWhiteActive,
        to: "/app/connectorhome",
        id: ["dataPrivacyModal", "dataStorageModal", "rbipolicy"],
        classChange: "mm-collapse",
        content: [
            {
                title: "Privacy Policy",
                iconStyle: imagepaths.PrivacyPolicyWhite,
                iconActive: imagepaths.PrivacyPolicyWhiteActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataPrivacyModal",
                showTitle: true
            },
            {
                title: "Terms and Conditions",
                iconStyle: imagepaths.MasterDataIconWhite,
                iconActive: imagepaths.MasterDataIconWhiteActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataStorageModal",
            }
        ],
    },
];
